export const Players = Object.freeze({
    Host: Symbol("Player"),
    Guest: Symbol("Player"),
    oposite: (pl) => {
        return pl == Players.Host ? Players.Guest : Players.Host
    }
})

export const Colors = Object.freeze({
    [Players.Host]: "Red",
    [Players.Guest]: "Blue"
})